import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Button from '../Button';
import getRedirectUrlAfterLogin from 'utils/getRedirectUrlAfterLogin';

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  sectionAlt: {
    backgroundColor: 'rgba(245, 245, 245, 0.3)',
  },
  container: {
    maxWidth: '1280px',
  },
  imageContainer: {
    animation: '$fadeIn 0.6s ease-out',
  },
  imageWrapper: {
    position: 'relative',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    animation: '$fadeInUp 0.8s ease-out',
  },
  title: {
    fontSize: '1.875rem',
    fontWeight: 700,
    color: '#121212',
    lineHeight: 1.3,
    [theme.breakpoints.up('md')]: {
      fontSize: '2.25rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '2.25rem',
    },
  },
  description: {
    fontSize: '1.125rem',
    color: '#616161',
    lineHeight: 1.7,
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(20px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

export default function FeatureSection({ title, description, image, imageAlt, reverse = false }) {
  const classes = useStyles();

  const handleCreateNowClick = () => {
    window.location.href = getRedirectUrlAfterLogin();
  };

  return (
    <section className={`${classes.section} ${reverse ? classes.sectionAlt : ''}`}>
      <Container className={classes.container}>
        <Grid container spacing={6} alignItems="center" direction={reverse ? 'row-reverse' : 'row'}>
          <Grid item xs={12} lg={6}>
            <Box className={classes.imageContainer}>
              <Box className={classes.imageWrapper}>
                <img src={image} alt={imageAlt} className={classes.image} />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} lg={6}>
            <Box className={classes.content}>
              <Typography className={classes.title} component="h3">
                {title}
              </Typography>
              <Typography className={classes.description}>{description}</Typography>
              <Box>
                <Button
                  size="large"
                  variant="contained"
                  onClick={handleCreateNowClick}
                  component="a"
                >
                  Create Now – It's Free
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}
